import { ApiClient } from '@/lib/apiClient';
import type { DefaultFilters, ListResponse } from '@/types/api';
import type { FacilityOutput } from '@/types/facilityOutput';
import type { CreateMassBalance, MassBalance } from '@/types/massBalance';

export default class MassBalanceService extends ApiClient<MassBalance, CreateMassBalance> {

  constructor() {
    super('/v1/massbalance', 'id');
  }

  async autoAssign(identifier: number, ignoreProducts: boolean = false, signal?: AbortSignal): Promise<void> {
    try {
      const response = await this.apiClient.get<void>(`/autoassign/${identifier}`, { signal, params: { ignoreProducts } });
      return response.data
    } catch (error) {
      throw error
    }
  }

  async resetAutoAssign(identifier: number, signal?: AbortSignal): Promise<void> {
    try {
      const response = await this.apiClient.get<void>(`/resetautoassign/${identifier}`, { signal })
      return response.data
    } catch (error) {
      throw error
    }
  }

  async checkProductionInputOutputQuantity(identifier: number, signal?: AbortSignal): Promise<{
    success: true,
    message: string,
  }> {
    try {
      const response = await this.apiClient.get<{
        success: true,
        message: string,
      }>(`/checkProductionInputOutputQuantity/${identifier}`, { signal })
      return response.data
    } catch (error) {
      throw error
    }
  }

  async loadFacilityOutput(identifier: number, signal?: AbortSignal): Promise<{
    success: true,
    message: string,
  }> {
    try {
      const response = await this.apiClient.get<{
        success: true,
        message: string,
      }>(`/loadfacilityoutput/${identifier}`, { signal })
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getFacilityProductionOutput(massBalanceId: number, signal?: AbortSignal): Promise<FacilityOutput[]> {
    const response = await this.apiClient.get<FacilityOutput[]>(
      `/facilityproductionoutput/${massBalanceId}`,
      {
        signal,
      }
    )
    return response.data
  }
}
